import * as adminActions from '../actions/admin';

const initialState = {
    accountToEdit: null,
    searchUsers: [],
    isSearchingUsers: false,
    isMoreUsersToLoad: true,
    searchUsersInitialised: false,
    searchText: '',
    isRemovingUser: false,
    isAuthenticatingAsUser: false,
    userToDelete: null,
    userToAuthenticateAs: null,
    isAccountLocked: 0
};

export default (state = initialState, action) => {
    switch (action.type) {

        case adminActions.USER_TO_AUTHENTICATE_UPDATED:
            return {
                ...state,
                userToAuthenticateAs: action.user
            };

        case adminActions.IS_AUTHENTICATING_AS_USER_STATUS_CHANGED:
            return {
                ...state,
                isAuthenticatingAsUser: action.isAuthenticating
            };

        case adminActions.USER_TO_DELETE_UPDATED:
            return {
                ...state,
                userToDelete: action.user
            };

        case adminActions.IS_REMOVING_USER_STATUS_CHANGED:
            return {
                ...state,
                isRemovingUser: action.isRemoving
            };

        case adminActions.RESET_SEARCH_USERS:
            return {
                ...state,
                searchUsers: [],
                isSearchingUsers: false,
                isMoreUsersToLoad: true,
                searchUsersInitialised: false
            };

        case adminActions.USER_TO_EDIT_RECEIVED:
            return {
                ...state,
                accountToEdit: action.user
            };

        case adminActions.SEARCH_USERS_RECEIVED:
            return {
                ...state,
                searchUsers: action.users,
                searchUsersInitialised: true,
                isMoreUsersToLoad: action.isMoreToLoad
            };

        case adminActions.LOAD_MORE_USERS_RECEIVED:
            return {
                ...state,
                searchUsers: [...state.searchUsers, ...action.users],
                searchUsersInitialised: true,
                isMoreUsersToLoad: action.isMoreToLoad
            };


        case adminActions.SEARCH_USERS_TEXT_CHANGED:
            return {
                ...state,
                searchText: action.searchText
            };

        case adminActions.IS_SEARCHING_USERS_CHANGED:
            return {
                ...state,
                isSearchingUsers: action.isSearching
            };
        case adminActions.SET_IS_ACCOUNT_LOCKED:
            return {
                ...state,
                isAccountLocked: action.isAccountLocked
            }

        default:
            return state;
    }
};